export enum SmtpProvider {
  GMAIL = 'gmail',
  OUTLOOK = 'outlook',
  ZOHO = 'zoho',
  YAHOO = 'yahoo',
  CUSTOM = 'custom',
}

export interface Smtp {
  _id: string;
  name: string;
  provider: SmtpProvider;
  smtpHost: string;
  port: number;
  userEmail: string;
  username: string;
  password: string;
  isActive: boolean;
  isDefault: boolean;
  description?: string;
  useSSL: boolean;
  useTLS: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSmtpData {
  name: string;
  provider: SmtpProvider;
  smtpHost: string;
  port: number;
  userEmail: string;
  username: string;
  password: string;
  isActive?: boolean;
  isDefault?: boolean;
  description?: string;
  useSSL?: boolean;
  useTLS?: boolean;
}

export interface UpdateSmtpData {
  name?: string;
  provider?: SmtpProvider;
  smtpHost?: string;
  port?: number;
  userEmail?: string;
  username?: string;
  password?: string;
  isActive?: boolean;
  isDefault?: boolean;
  description?: string;
  useSSL?: boolean;
  useTLS?: boolean;
}

export interface SmtpProviderOption {
  value: string;
  label: string;
} 